import Field from '../Field/Field';

import { getSetClassName } from '../../lib/set';

import { SetInterface, FieldInterface } from 'edocatbase/Form';

export interface SetComponentInterface {
  set: SetInterface;
  formInstanceId: string;
  innerFormInstanceId?: string;
  readOnly: boolean;
  disabled: boolean;
}

export default class StructureSet extends window.React.PureComponent<SetComponentInterface> {
  render() {
    const { set, formInstanceId, innerFormInstanceId, readOnly, disabled } = this.props;

    if (
      (readOnly && set.label === window.Alfresco.messages.global['workflow.set.response']) ||
      !set.children ||
      set.children.length < 1
    ) {
      return null;
    }

    const className = getSetClassName(set.template || '');
    return (
      <div className="fieldset-wrap">
        {set.label && !set.label.startsWith('cm:') && (
          <h2 className="set-title">{set.label}</h2>
        )}
        <fieldset className={`form-fieldset ${className}`}>
          {
            // @ts-ignore
            set.children.map((field: SetInterface | FieldInterface) => {
              if (field.kind && field.kind === 'set') {
                return (
                  <StructureSet
                    {...{ formInstanceId, innerFormInstanceId, set: field }}
                    key={field.id + field.label}
                    readOnly={readOnly}
                    disabled={disabled}
                  />
                );
              }

              return (
                <Field
                  key={field.id}
                  fieldName={field.id}
                  {...{ formInstanceId, innerFormInstanceId }}
                  readOnly={readOnly}
                  setDisabled={disabled}
                />
              );
            })
          }
        </fieldset>
      </div>
    );
  }
}
